import { WebHaptics, type HapticInput } from "web-haptics";

/**
 * Levels of the navigation hierarchy, from coarsest to finest:
 * - page:    top-level route ↔ route (Home, Gallery, About, …)
 * - content: content item ↔ content item within the detail view
 * - image:   sub-item ↔ sub-item (media) within a single content item
 */
export type TransitionLevel = "page" | "content" | "image";

const STRONG: HapticInput = [{ duration: 35, intensity: 0.7 }];
const LIGHT: HapticInput = [{ duration: 22, intensity: 0.5 }];

const HAPTIC_BY_LEVEL: Record<TransitionLevel, HapticInput> = {
  page: STRONG,
  content: STRONG,
  image: LIGHT,
};

// Single app-wide instance. The constructor is inert (no DOM or audio work
// until the first trigger) and trigger() no-ops gracefully on devices without
// the Vibration API, so a module-level singleton is safe in this client SPA.
const haptics = new WebHaptics();

/**
 * Fire the haptic that corresponds to a navigation transition.
 *
 * Call this synchronously from a user gesture (pointerup / click) so the
 * Vibration API keeps its user-activation and is permitted to run.
 */
export function triggerTransitionHaptic(level: TransitionLevel): void {
  void haptics.trigger(HAPTIC_BY_LEVEL[level]);
}
